import React from 'react';
import {cn} from "@/ReactInit/Scripts/DashboardPage/utils/dashboardHelpers";

interface DashboardCardProps {
  children: React.ReactNode
  as?: "div" | "section"
  className?: string
  size?: "regular" | "slim" | "vipps";
  variant?: "default" | "ghost";
}

export const DashboardCard = (
  {
    children,
    as = "div",
    className,
    size = "regular",
    variant = "default"
  }: DashboardCardProps) => {

  const isGhost = variant === "ghost";

  const cardSize = () => {
    if (isGhost) return "";
    switch (size) {
      case "slim":
        return "p-5";
      case "vipps":
        return "px-8 py-16 tablet:px-10 tablet:py-20";
      case "regular":
      default:
        return "p-8 tablet:p-10";
    }
  }

  const classes = isGhost ? "" : "bg-brown-50 rounded-4xl"

  return as === "section" ?
    <section className={cn(cardSize(), classes, className)}>{children}</section> :
    <div className={cn(cardSize(), classes, className)}>{children}</div>
}